(function() {
  'use strict';

  class ProductImageGallery {
    constructor(element) {
      this.productItem = element;
      this.gridCell = element.closest('.Grid__Cell') || element.parentElement;
      
      if (this.productItem.dataset.galleryInitialized === 'true') {
        return;
      }
      
      this.imageWrapper = element.querySelector('.ProductItem__ImageWrapper--hasGallery');
      
      if (!this.imageWrapper) {
        return;
      }

      this.gallery = this.imageWrapper.querySelector('[data-image-gallery]');
      this.images = Array.from(this.gallery.querySelectorAll('.ProductItem__GalleryImage'));
      this.navigation = this.imageWrapper.querySelector('[data-navigation]');
      
      if (this.images.length <= 1 || !this.navigation) {
        return;
      }

      
      this.prevBtn = this.navigation.querySelector('[data-nav-prev]');
      this.nextBtn = this.navigation.querySelector('[data-nav-next]');
      this.dots = Array.from(this.navigation.querySelectorAll('[data-dot]'));
      this.currentIndex = 0;
      this.isMobile = window.innerWidth <= 768;
      this.holdTimer = null;
      this.isHolding = false;
      this.holdInterval = null;
      this.hideTimeout = null;
      this.advanceTimeout = null;

      this.productItem.dataset.galleryInitialized = 'true';
      this.init();
    }

    init() {
      // Preload images to prevent white screen
      this.preloadImages();
      
      if (this.isMobile) {
        this.initMobileTouch();
      } else {
        this.initDesktopHover();
      }

      this.updateGallery();
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    preloadImages() {
      this.images.slice(0, 2).forEach(img => {
        if (img && img.dataset.src) {
          const imageUrl = img.dataset.src.replace('{width}', '800');
          
          const preloadImg = new Image();
          preloadImg.src = imageUrl;
          
          if (window.lazySizes) {
            img.classList.add('lazypreload');
            window.lazySizes.loader.unveil(img);
          }
        }
      });
    }

    handleResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;

      if (wasMobile !== this.isMobile) {
        this.cleanup();
        this.init();
      }
    }

    initDesktopHover() {
      this.boundHandlePrev = this.handlePrev.bind(this);
      this.boundHandleNext = this.handleNext.bind(this);
      this.boundHandleMouseEnter = this.handleMouseEnter.bind(this);
      this.boundHandleMouseLeave = this.handleMouseLeave.bind(this);
      
      // Hide arrows for products with 2 or fewer images
      if (this.images.length <= 2) {
        this.prevBtn.style.display = 'none';
        this.nextBtn.style.display = 'none';
        this.prevBtn.style.visibility = 'hidden';
        this.nextBtn.style.visibility = 'hidden';
        this.prevBtn.classList.add('is-hidden');
        this.nextBtn.classList.add('is-hidden');
      } else {
        this.prevBtn.addEventListener('click', this.boundHandlePrev);
        this.nextBtn.addEventListener('click', this.boundHandleNext);
      }
      
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToImage(index));
      });

      this.gridCell.addEventListener('mouseenter', this.boundHandleMouseEnter);
      this.gridCell.addEventListener('mouseleave', this.boundHandleMouseLeave);
    }

    handleMouseLeave() {
      this.isHovering = false;
      this.navigation.style.opacity = '0';
      this.navigation.style.visibility = 'hidden';
      this.navigation.style.pointerEvents = 'none';
      
      setTimeout(() => {
        if (!this.isHovering) {
          this.goToImage(0);
        }
      }, 100);
    }

    initMobileTouch() {
      let touchStartTime = 0;
      let touchStartY = 0;
      let touchStartX = 0;
      let isScrolling = false;
      let isHorizontalSwipe = false;
      let imageShowTimer = null;

      const resetToFirst = () => {
        if (this.currentIndex !== 0) {
          this.goToImage(0);
        }
        isScrolling = false;
        isHorizontalSwipe = false;
      };

      const startHold = (e) => {
        if (e.touches) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }
        touchStartTime = Date.now();
        isScrolling = false;
        isHorizontalSwipe = false;

        // Delay showing second image so a horizontal swipe can be detected first
        if (imageShowTimer) clearTimeout(imageShowTimer);
        if (this.currentIndex === 0 && this.images.length > 1) {
          imageShowTimer = setTimeout(() => {
            if (!isHorizontalSwipe && this.currentIndex === 0) {
              this.goToImage(1);
            }
          }, 80);
        }
      };

      const checkScroll = (e) => {
        if (e.touches && !isScrolling) {
          const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
          const deltaX = Math.abs(e.touches[0].clientX - touchStartX);

          if (deltaX > 5 || deltaY > 5) {
            isScrolling = true;
            // Horizontal swipe — cancel image switch and reset to first image
            if (deltaX > deltaY) {
              isHorizontalSwipe = true;
              if (imageShowTimer) {
                clearTimeout(imageShowTimer);
                imageShowTimer = null;
              }
              if (this.currentIndex !== 0) {
                this.goToImage(0);
              }
            }
          }
        }
      };

      const endHold = (e) => {
        if (imageShowTimer) {
          clearTimeout(imageShowTimer);
          imageShowTimer = null;
        }
        const touchDuration = Date.now() - touchStartTime;

        if (!isScrolling && touchDuration < 300) {
          const url = this.imageWrapper.getAttribute('data-product-url');
          if (url) {
            window.location.href = url;
          }
          return;
        }

        if (!isHorizontalSwipe && this.currentIndex !== 0) {
          this.goToImage(0);
        }
        isScrolling = false;
        isHorizontalSwipe = false;
      };

      const cancelHold = () => {
        if (imageShowTimer) {
          clearTimeout(imageShowTimer);
          imageShowTimer = null;
        }
        if (this.currentIndex !== 0) {
          this.goToImage(0);
        }
        isScrolling = false;
        isHorizontalSwipe = false;
      };

      // Handle touches outside the product to reset
      const handleOutsideTouch = (e) => {
        if (!this.imageWrapper.contains(e.target) && this.currentIndex !== 0) {
          resetToFirst();
        }
      };

      this.boundHandleOutsideTouch = handleOutsideTouch;

      this.imageWrapper.addEventListener('touchstart', startHold, { passive: true });
      this.imageWrapper.addEventListener('touchmove', checkScroll, { passive: true });
      this.imageWrapper.addEventListener('touchend', endHold, { passive: true });
      this.imageWrapper.addEventListener('touchcancel', cancelHold, { passive: true });

      // Reset when touching anywhere else on the page
      document.addEventListener('touchstart', handleOutsideTouch, { passive: true });
    }

    startAutoAdvance() {
      this.holdInterval = setInterval(() => {
        this.nextImage();
      }, 800);
    }

    stopAutoAdvance() {
      if (this.holdInterval) {
        clearInterval(this.holdInterval);
        this.holdInterval = null;
      }
    }

    handleMouseEnter() {
      this.isHovering = true;
      
      // Don't show navigation arrows for products with 2 or fewer images
      if (this.images.length > 2) {
        this.navigation.style.opacity = '1';
        this.navigation.style.visibility = 'visible';
        this.navigation.style.pointerEvents = 'auto';
      }
      
      if (this.currentIndex === 0 && this.images.length > 1) {
        setTimeout(() => {
          if (this.currentIndex === 0 && this.isHovering) {
            this.nextImage();
          }
        }, 300);
      }
    }

    handlePrev(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.currentIndex > 0) {
        this.prevImage();
      }
    }

    handleNext(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.currentIndex < this.images.length - 1) {
        this.nextImage();
      }
    }

    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.updateGallery();
    }

    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.updateGallery();
    }

    goToImage(index) {
      this.currentIndex = index;
      this.updateGallery();
    }

    updateGallery() {
      this.images.forEach((img, index) => {
        if (index === this.currentIndex) {
          img.classList.add('is-active');
        } else {
          img.classList.remove('is-active');
        }
      });

      this.dots.forEach((dot, index) => {
        if (index === this.currentIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });

      if (this.currentIndex === 0) {
        this.prevBtn.classList.add('is-disabled');
      } else {
        this.prevBtn.classList.remove('is-disabled');
      }

      if (this.currentIndex === this.images.length - 1) {
        this.nextBtn.classList.add('is-disabled');
      } else {
        this.nextBtn.classList.remove('is-disabled');
      }
      
      // Only show navigation on hover if there are more than 2 images
      if (this.isHovering && this.navigation && this.images.length > 2) {
        this.navigation.style.opacity = '1';
        this.navigation.style.visibility = 'visible';
        this.navigation.style.pointerEvents = 'auto';
      }
    }

    cleanup() {
      this.stopAutoAdvance();
      clearTimeout(this.holdTimer);
      clearTimeout(this.hideTimeout);
      clearTimeout(this.advanceTimeout);
      
      if (this.boundHandleMouseEnter && this.boundHandleMouseLeave && this.gridCell) {
        this.gridCell.removeEventListener('mouseenter', this.boundHandleMouseEnter);
        this.gridCell.removeEventListener('mouseleave', this.boundHandleMouseLeave);
      }
      
      if (this.boundHandlePrev && this.boundHandleNext) {
        this.prevBtn.removeEventListener('click', this.boundHandlePrev);
        this.nextBtn.removeEventListener('click', this.boundHandleNext);
      }

    }
  }

  function initGalleries() {
    const productItems = document.querySelectorAll('.ProductItem[data-product-images]:not([data-gallery-initialized])');
    productItems.forEach(item => {
      const imageCount = parseInt(item.getAttribute('data-product-images'), 10);
      if (imageCount > 1) {
        new ProductImageGallery(item);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleries);
  } else {
    initGalleries();
  }

  setTimeout(() => initGalleries(), 500);
  setTimeout(() => initGalleries(), 1000);
  setTimeout(() => initGalleries(), 2000);
  document.addEventListener('shopify:section:load', () => {
    setTimeout(initGalleries, 100);
  });
  
  document.addEventListener('shopify:section:reorder', () => {
    setTimeout(initGalleries, 100);
  });

  document.addEventListener('collection:updated', () => {
    setTimeout(initGalleries, 100);
  });

  document.addEventListener('theme:product-recommendations:loaded', () => {
    setTimeout(initGalleries, 100);
  });

  document.addEventListener('flickity:ready', () => {
    setTimeout(initGalleries, 100);
  });

  const originalCarousel = window.Carousel;
  if (originalCarousel) {
    window.Carousel = function() {
      const instance = originalCarousel.apply(this, arguments);
      setTimeout(initGalleries, 200);
      return instance;
    };
    window.Carousel.prototype = originalCarousel.prototype;
  }
  
  const observer = new MutationObserver((mutations) => {
    let hasNewProducts = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('ProductItem')) {
            if (node.dataset.galleryInitialized !== 'true') {
              const imageCount = parseInt(node.getAttribute('data-product-images'), 10);
              if (imageCount > 1) {
                hasNewProducts = true;
              }
            }
          } else if (node.querySelectorAll) {
            const items = node.querySelectorAll('.ProductItem[data-product-images]:not([data-gallery-initialized])');
            if (items.length > 0) {
              hasNewProducts = true;
            }
          }
        }
      });
    });
    
    if (hasNewProducts) {
      setTimeout(initGalleries, 100);
    }
  });

  const observeContainers = () => {
    const containers = [
      '.ProductList',
      '.ProductRecommendations',
      '.Carousel',
      '[data-section-type="recently-viewed-products"]',
      '[data-section-type="product-recommendations"]',
      '[data-section-type="featured-collections"]',
      '.Section'
    ];
    
    containers.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (element && !element.dataset.observing) {
          element.dataset.observing = 'true';
          observer.observe(element, {
            childList: true,
            subtree: true
          });
        }
      });
    });
  };

  // Start observing
  observeContainers();
  
  document.addEventListener('shopify:section:load', () => {
    setTimeout(observeContainers, 100);
  });
})();

